import { StoreState } from '../index';

export const comparisonSelector = (state: StoreState) => state.comparison;
